export const enTranslations = {
  app_name: 'Balderdashology',
  nav: {
    home: 'Home',
    investigations: 'Our Investigations',
    investigators: 'Our Investigators',
    login: 'Sign In',
    register: 'Sign Up',
    logout: 'Sign Out',
    streamerAdmin: 'Admin',
    my_profile: 'My profile',
    about: 'About',
    theme_toggle_to_dark: 'Switch to dark theme',
    theme_toggle_to_light: 'Switch to light theme',
  },
  home: {
    hero_title: 'Exposing Balderdash',
    hero_subtitle:
      'Crowdsourced investigations into political lies, manipulative rhetoric, and misinformation.',
    hero_cta: 'View Our Investigations',
    recent_title: 'Recent Investigations',
    see_more: 'See All Investigations',
    no_investigations: 'No investigations yet.',
    manifesto_quote: 'When beliefs and convictions matter more than the factual reality.',
    stats_investigations: 'Active Investigations',
    stats_total_investigations: 'Total Investigations',
    stats_investigators: 'Investigators',
    stats_closed_investigations: 'Closed Investigations',
    carousel_prev: 'Previous',
    carousel_next: 'Next',
    lead_kicker: 'Featured investigation',
    headlines_title: 'Ongoing investigations',
    headlines_completed_title: 'Completed investigations',
    secondary_title: 'Recent Investigations',
    latest_title: 'Latest',
    category_section_title: '{{category}}',
    see_all: 'See all investigations',
    breaking_label: 'Breaking',
    empty_state: 'No investigations yet.',
  },
  investigations: {
    title: 'Enquêtes',
    page_title: 'Our Investigations',
    search_placeholder: 'Search investigations...',
    filter_category: 'All categories',
    filter_category_label: 'Filter by category',
    sort_by: 'Sort by',
    sort_date: 'Date',
    sort_title: 'Title',
    sort_category: 'Category',
    no_results: 'No investigations found.',
    view_details: 'View Details',
    leads_count: '{{count}} lead',
    leads_count_plural: '{{count}} leads',
    suggest_new: 'Suggest an Investigation',
    suggestions_title: 'Suggested Investigations',
    suggestions_subtitle: 'Vote for investigations you want to see!',
    vote: 'Vote',
    voted: 'Voted',
    votes: '{{count}} votes',
    your_suggestion: 'Your suggestion',
    suggestion_title_label: 'Title',
    suggestion_description_label: 'Description (optional)',
    suggestion_submit: 'Submit Suggestion',
    sort_most_voted: 'Most Voted',
    sort_newest: 'Newest',
    login_to_vote: 'Sign in to vote',
    login_to_suggest: 'Sign in to suggest an investigation',
    suggestion_col_title: 'Title',
    suggestion_col_by: 'Submitted by',
    suggestion_col_date: 'Date',
    suggestion_col_votes: 'Votes',
    suggestion_empty: 'No suggestions yet.',
    tab_active: 'Ongoing Investigations',
    tab_inactive: 'Completed Investigations',
  },
  investigators: {
    page_title: 'Our Investigators',
    page_subtitle: 'Community members who contribute to investigations.',
    empty: 'No investigators yet.',
    unknown: 'Unknown',
  },
  investigation_detail: {
    by: 'By',
    category: 'Category',
    leads: 'Leads',
    no_leads: 'No leads yet for this investigation.',
    lead_url: 'URL',
    lead_description: 'Description',
    lead_submitted_by: 'Submitted by',
    lead_date: 'Date',
    view_lead: 'View Details',
    add_lead_button: 'Add Lead',
    add_lead_title: 'Submit a Lead',
    add_lead_title_label: 'Title',
    add_lead_title_placeholder: 'e.g., New fact on climate manipulation',
    add_lead_description_label: 'Description',
    add_lead_description_placeholder: 'Briefly describe this lead...',
    add_lead_submit: 'Submit Lead',
    add_lead_success: 'Lead submitted successfully!',
    add_lead_login_prompt: 'Sign in to submit a lead',
    not_found_title: 'Investigation not found',
    not_found_body: "This investigation doesn't exist or has been removed.",
    team_button: 'View team',
    team_modal_title: 'Investigation Team',
    team_lead_badge: 'Lead',
    team_empty: 'No team members yet.',
    notes_title: 'Analyses and Synthesis',
    live_label: 'Upcoming Live',
    live_at: 'at',
    live_replay_label: 'Replay available',
    live_watch_twitch: 'Watch on Twitch',
    live_watch_youtube: 'Watch on YouTube',
    live_watch_video: 'Watch the video',
    live_video_label: 'Associated video',
    live_watch_replay: 'Watch Replay',
    lead_drag_handle: 'Drag lead to reorder',
    lead_reorder_success: 'Lead order updated',
    lead_reorder_failed: 'Failed to reorder leads: {{error}}',
  },
  investigation_form: {
    public_urls_title: 'Public addresses',
    public_urls_rename_warning:
      'Changing the title (or its translation) changes the address in that language; the old address redirects automatically.',
    public_url_source_fallback: 'Derived from the source title',
    public_url_copy: 'Copy the address',
    public_url_copied: 'Address copied',
    public_url_open: 'Open the page',
  },
  lead_detail: {
    title: 'Lead Detail',
    description: 'Description',
    date: 'Submitted on',
    not_found_title: 'Lead not found',
    not_found_body: "This lead doesn't exist or has been removed.",
    badge: 'Lead',
    fallback_title: 'Lead',
    facts: 'Facts',
    no_facts: 'No facts yet for this lead.',
    add_fact_button: 'Add Fact',
    add_fact_title: 'Add a Fact',
    fact_title_label: 'Title',
    fact_title_placeholder: 'e.g., Article from Le Monde',
    fact_description_label: 'Description',
    fact_description_placeholder: 'Briefly describe this fact...',
    fact_url_label: 'Source URL',
    fact_url_placeholder: 'https://...',
    fact_no_source_title: 'Fact without a source',
    fact_no_source_message:
      'You did not provide a source URL for this fact. It will be recorded without a verifiable reference. Do you want to continue?',
    fact_no_source_cancel: 'Add a source',
    fact_no_source_confirm: 'Save without a source',
    fact_image_label: 'Image (optional)',
    add_fact_submit: 'Add Fact',
    add_fact_success: 'Fact added successfully!',
    add_fact_login_prompt: 'Sign in to add a fact',
    fact_delete_confirm: 'Delete this fact?',
    fact_deleted: 'Fact deleted',
    fact_delete_failed: 'Failed to delete fact: {{error}}',
    fact_edit_title: 'Edit fact',
    fact_edit_submit: 'Save changes',
    fact_score_validated_label: 'Validated score',
    fact_score_average_label: 'Average score',
    fact_score_voters: '{{count}} vote(s)',
    fact_score_none: 'None',
    fact_score_vote_prompt: 'Evaluate the fact',
    fact_score_your_vote: 'Your evaluation',
    fact_score_validate_updated: 'Validated score updated',
    fact_score_validate_success: 'Validated score saved',
    fact_score_validate_error: 'Failed to update the validated score',
    fact_score_validate_button: 'Validate',
    fact_score_validate_label: 'Validate score',
    fact_score_clear_validated: 'Clear validated',
    fact_reset_votes: 'Reset votes',
    fact_reset_votes_confirm: 'Reset all votes for this fact?',
    fact_reset_votes_success: 'Votes reset',
    fact_reset_votes_failed: 'Failed to reset votes',
    fact_updated: 'Fact updated!',
    fact_update_failed: 'Failed to update fact: {{error}}',
    fact_see_more: 'See more',
    fact_see_less: 'See less',
    fact_source_button: 'Source',
    fact_published: 'Published',
    fact_unpublished: 'Unpublished',
    fact_publish_button: 'Publish',
    fact_publish_success: 'Fact published successfully',
    fact_publish_failed: 'Failed to publish fact: {{error}}',
    fact_unpublish_button: 'Unpublish',
    fact_unpublish_success: 'Fact unpublished successfully',
    fact_unpublish_failed: 'Failed to unpublish fact: {{error}}',
    fact_drag_handle: 'Drag fact to reorder',
    fact_reorder_success: 'Fact order updated',
    fact_reorder_failed: 'Failed to reorder facts: {{error}}',
    edit_lead: 'Edit lead',
    lead_published: 'Published',
    lead_unpublished: 'Unpublished',
    lead_publish_button: 'Publish',
    lead_unpublish_button: 'Unpublish',
    lead_publish_success: 'Lead published successfully',
    lead_publish_failed: 'Failed to publish lead: {{error}}',
    lead_unpublish_success: 'Lead unpublished successfully',
    lead_unpublish_failed: 'Failed to unpublish lead: {{error}}',
    notes_title: 'Analyses and Synthesis',
    source_title: 'Original Source',
    source_add_button: 'Add source',
    source_edit_button: 'Edit source',
    source_delete_confirm: 'Delete the source?',
    source_deleted: 'Source deleted',
    source_delete_failed: 'Failed to delete source: {{error}}',
    source_dialog_add_title: 'Add a source',
    source_dialog_edit_title: 'Edit source',
    source_title_label: 'Title *',
    source_title_placeholder: 'e.g. Le Monde article, official report…',
    source_description_label: 'Description *',
    source_description_placeholder: 'Briefly describe this source…',
    source_image_label: 'Image (optional)',
    source_url_label: 'Source URL *',
    source_url_placeholder: 'https://...',
    source_submit_add: 'Add',
    source_submit_edit: 'Save',
    source_saved: 'Source saved',
    source_save_failed: 'Failed to save source: {{error}}',
    source_no_source: 'No source has been provided.',
  },
  auth: {
    login_title: 'Sign In',
    login_subtitle: 'Access your Balderdashology account',
    register_title: 'Create Account',
    register_subtitle: 'Join the Balderdashology community',
    username: 'Username',
    email: 'Email',
    password: 'Password',
    display_name: 'Display Name (optional)',
    login_button: 'Sign In',
    register_button: 'Create Account',
    no_account: "Don't have an account?",
    has_account: 'Already have an account?',
    register_link: 'Sign up',
    login_link: 'Sign in',
    streamer_login: 'Streamer Login',
    // Social login
    social_or: 'or continue with',
    social_google: 'Continue with Google',
    social_twitch: 'Continue with Twitch',
    // 2FA
    two_factor_title: 'Two-Factor Authentication',
    two_factor_subtitle: 'Enter the 6-digit code from your authenticator app.',
    two_factor_code_label: 'Authentication Code',
    two_factor_code_placeholder: '000000',
    two_factor_verify_button: 'Verify',
    two_factor_back: 'Back to Login',
    // OAuth callback
    oauth_completing: 'Completing sign in…',
    oauth_error_title: 'Authentication Error',
    oauth_error_subtitle: 'Something went wrong during sign in.',
    oauth_back_to_login: 'Back to Sign In',
    oauth_error_denied: 'You denied access.',
    oauth_error_failed: 'Sign in failed. Please try again.',
    oauth_error_unknown: 'An unknown error occurred.',
    oauth_error_no_account: 'No account found. Please register first.',
    oauth_error_account_pending: 'Your account is awaiting activation by an administrator.',
    recaptcha_notice_prefix: 'This site is protected by reCAPTCHA and the Google',
    recaptcha_privacy: 'Privacy Policy',
    recaptcha_and: 'and',
    recaptcha_terms: 'Terms of Service',
    recaptcha_notice_suffix: 'apply.',
    register_pending_title: 'Registration pending approval',
    register_pending_body:
      'Your account has been created. An administrator must validate it before you can log in.',
  },
  common: {
    loading: 'Loading...',
    error: 'An error occurred.',
    back: 'Back',
    by: 'by',
    on: 'on',
    investigation: 'Investigation',
    slide: 'Slide {{number}}',
    refreshing: 'Refreshing...',
    cancel: 'Cancel',
    created_at: 'Created:',
    page_prev: 'Previous',
    page_next: 'Next',
    page_info: 'Page {{page}} / {{total}}',
    notes_edit: 'Edit',
    notes_add: 'Add a note',
    delete: 'Delete',
    submitted_by: 'Submitted by',
    image_enlarge: 'Enlarge image',
    image_enlarge_named: 'Enlarge image: {{alt}}',
    image_preview: 'Image preview',
    image_close: 'Close image',
    back_to_top: 'Back to top',
  },
  validation: {
    url_invalid: 'Please enter a valid URL.',
    required: 'This field is required.',
    max_chars: 'Maximum {{count}} characters.',
    comment_empty: 'The comment cannot be empty.',
    comment_max: 'Maximum 2000 characters.',
    name_min: 'Name must be at least 2 characters.',
    name_max: 'Name must be at most 250 characters.',
    desc_max: 'Description must be at most 20,000 characters.',
    id_min: 'Investigation ID must be at least 2 characters.',
    id_max: 'Investigation ID must be at most 200 characters.',
    image_url: 'Must be a valid URL.',
    username_min: 'At least 3 characters required.',
    username_max: 'At most 30 characters.',
    email_invalid: 'Invalid email address.',
    password_min: 'Minimum 8 characters.',
    description_required: 'Description is required.',
    account_pending: 'Your account is awaiting approval by an administrator.',
  },
  editor: {
    bold: 'Bold',
    italic: 'Italic',
    strike: 'Strikethrough',
    underline: 'Underline',
    heading2: 'Heading 2',
    heading3: 'Heading 3',
    bullet_list: 'Bullet list',
    ordered_list: 'Numbered list',
    quote: 'Quote',
    code: 'Code',
    insert_image: 'Insert image',
    uploading: 'Uploading…',
    image_too_large: 'Image exceeds the maximum allowed size (30 MB).',
    image_invalid_type: 'Unsupported file format (JPG, PNG, WebP, GIF only).',
    upload_failed: 'Failed to upload the image. Please try again.',
    image_resize_hint: 'Once inserted, drag an image corner to resize it.',
    save: 'Save',
    cancel: 'Cancel',
    no_notes: 'No notes yet.',
  },
  footer: {
    tagline: 'A citizen-led, collaborative initiative against misinformation.',
    rights: '© {{year}} Balivernologie. All rights reserved.',
    rights_year: '© {{year}} Balivernologie.',
    rights_reserved: 'All rights reserved.',
    social_networks: 'Social networks',
    legal: {
      title: 'Legal',
      mentions_legales: 'Legal notice',
      confidentialite: 'Privacy policy',
      cookies: 'Cookies',
      manage_cookies: 'Manage cookie preferences',
    },
  },
  admin: {
    login_subtitle: 'Investigation Management',
    login_card_desc: 'Log in to manage your investigations and view leads',
    login_note: 'New to {{appName}}? This is a demo application for Twitch streamers.',
    login_welcome: 'Welcome Back',
    login_twitch_button: 'Log in with Twitch',
    login_or: 'or',
    login_terms: 'By logging in, you agree to our Terms of Service and Privacy Policy.',
    login_2fa_redirect:
      'Your account uses two-factor authentication. Please complete sign-in at the public login page.',
    settings_subtitle: 'Configure your {{appName}} experience',

    // Header / Sidebar
    header_subtitle: 'Investigation management',
    header_search_placeholder: 'Search leads… (Enter)',
    sidebar_admin: 'Admin',
    nav_dashboard: 'Dashboard',
    nav_categories: 'Categories',
    nav_investigations: 'Investigations',
    nav_comments: 'Comments',
    comments_col_investigation: 'Investigation',
    comments_col_total: 'Comments',
    comments_col_pending: 'Pending',
    comments_moderate_button: 'Moderate',
    comments_list_empty: 'No comments yet.',
    comments_moderation_title: 'Comment moderation',
    comments_moderation_empty: 'No comments pending validation.',
    comments_validate: 'Approve',
    comments_reject: 'Reject',
    comments_validated_toast: 'Comment approved',
    comments_rejected_toast: 'Comment rejected',
    nav_leads: 'Leads',
    nav_live: 'Live',
    nav_import_export: 'Import / Export',
    nav_translations: 'Translations',
    nav_settings: 'Settings',
    nav_profile: 'Profile',
    // Profile page
    profile_title: 'My Profile',
    profile_subtitle: 'Manage your account information',
    profile_info_title: 'Account Information',
    profile_info_desc: 'View and update your personal details',
    profile_username: 'Username',
    profile_role: 'Role',
    profile_display_name: 'Display Name',
    profile_display_name_placeholder: 'How you want to be known',
    profile_first_name: 'First Name',
    profile_first_name_placeholder: 'Your first name',
    profile_last_name: 'Last Name',
    profile_last_name_placeholder: 'Your last name',
    profile_email: 'E-Mail',
    profile_email_placeholder: 'Your email address',
    profile_email_conflict: 'This email address is already in use',
    profile_avatar_label: 'Profile picture',
    profile_bio_label: 'Bio',
    profile_bio_placeholder: 'Tell us a bit about yourself… (140 characters max)',
    profile_save: 'Save Changes',
    profile_save_success: 'Profile updated successfully',
    profile_save_error: 'Failed to update profile',
    // 2FA management
    profile_2fa_title: 'Two-Factor Authentication',
    profile_2fa_desc:
      'Add an extra layer of security to your account with a time-based one-time password.',
    profile_2fa_status_enabled: 'Enabled',
    profile_2fa_status_disabled: 'Disabled',
    profile_2fa_enable_btn: 'Enable 2FA',
    profile_2fa_disable_btn: 'Disable 2FA',
    profile_2fa_setup_instruction:
      'Scan this QR code with your authenticator app (Google Authenticator, Authy, 1Password…)',
    profile_2fa_manual_entry: 'Or enter this secret manually:',
    profile_2fa_confirm_label: 'Enter the 6-digit code to confirm',
    profile_2fa_confirm_placeholder: '000000',
    profile_2fa_confirm_btn: 'Confirm & Enable',
    profile_2fa_disable_instruction:
      'Enter the 6-digit code from your authenticator app to disable 2FA.',
    profile_2fa_disable_confirm_btn: 'Confirm & Disable',
    profile_2fa_cancel: 'Cancel',
    profile_2fa_enabled_success: '2FA has been enabled on your account.',
    profile_2fa_disabled_success: '2FA has been disabled.',
    profile_2fa_error: 'Invalid code. Please try again.',
    // Team management
    team_title: 'Investigation Team',
    team_subtitle: 'Manage the investigators for this investigation',
    team_empty: 'No investigators yet. Add team members to collaborate.',
    team_add: 'Add Investigator',
    team_remove: 'Remove',
    team_remove_confirm: 'Remove this investigator from the team?',
    team_removed: 'Investigator removed',
    team_added: 'Investigator added',
    team_add_dialog_title: 'Add an Investigator',
    team_search_placeholder: 'Search by username...',
    team_no_results: 'No users found',
    // Suggestions
    nav_suggestions: 'Suggestions',
    suggestions_page_title: 'Suggested Investigations',
    suggestions_page_subtitle: 'Review community suggestions and promote them to investigations',
    suggestions_empty_title: 'No suggestions yet',
    suggestions_empty_body: 'Users can suggest investigations from the public investigations page.',
    suggestions_col_title: 'Title',
    suggestions_col_description: 'Description',
    suggestions_col_votes: 'Votes',
    suggestions_col_by: 'Suggested by',
    suggestions_col_date: 'Date',
    suggestions_approve: 'Approve',
    suggestions_delete: 'Delete',
    suggestions_delete_confirm: 'Delete this suggestion? This cannot be undone.',
    suggestions_deleted: 'Suggestion deleted',
    suggestions_delete_failed: 'Failed to delete suggestion',
    suggestions_approve_dialog_title: 'Approve Suggestion',
    suggestions_approve_dialog_subtitle:
      'Fill in the remaining details to create an investigation from this suggestion.',
    suggestions_approved: 'Investigation created successfully!',
    suggestions_approve_failed: 'Failed to create investigation',
    suggestions_badge_votes: '{{count}} votes',
    suggestions_no_description: 'No description',
    // Investigators management
    nav_investigators: 'Investigators',
    investigators_page_title: 'Investigators Management',
    investigators_page_subtitle: 'Manage user accounts and validate new registrations',
    comments_subtitle: 'Moderate comments posted on investigations.',
    import_export_subtitle: 'Import and export investigations, leads and facts.',
    investigators_tab_pending: 'Pending ({{count}})',
    investigators_tab_all: 'All',
    investigators_col_user: 'User',
    investigators_col_email: 'Email',
    investigators_col_role: 'Role',
    investigators_col_status: 'Status',
    investigators_col_date: 'Registered',
    investigators_col_actions: 'Actions',
    investigators_enable: 'Enable',
    investigators_disable: 'Disable',
    investigators_enabled: 'Active',
    investigators_disabled: 'Pending',
    investigators_enabled_toast: 'Account enabled',
    investigators_disabled_toast: 'Account disabled',
    investigators_delete_confirm: 'Delete this account? This action is irreversible.',
    investigators_deleted: 'User deleted',
    investigators_delete_failed: 'Failed to delete user',
    investigators_role_user: 'user',
    investigators_role_admin: 'admin',
    investigators_role_moderator: 'moderator',
    investigators_role_updated: 'Role updated',
    investigators_empty: 'No users found',
    investigators_pending_empty: 'No accounts pending approval',
    logout: 'Log Out',
    login: 'Log In',
    header_title_dashboard: 'Dashboard',
    header_title_investigations: 'Investigations',
    header_title_new_investigation: 'New Investigation',
    header_title_edit_investigation: 'Edit Investigation',
    header_title_investigation_leads: 'Investigation Leads',
    header_title_lead_detail: 'Lead Detail',
    // Dashboard
    dash_stat_inv_title: 'Total Investigations',
    dash_stat_inv_desc: 'Create and manage investigations for your stream',
    dash_stat_leads_title: 'Total Leads',
    dash_stat_leads_desc: 'All leads submitted by viewers',
    dash_stat_activity_title: 'Recent Activity',
    dash_stat_activity_desc: 'New leads in the last hour',
    dash_stat_submitters_title: 'Top Submitters',
    dash_stat_submitters_desc: 'Unique viewers who submitted leads',
    dash_your_investigations: 'Your Investigations',
    dash_add_investigation: '+ Add Investigation',
    dash_no_investigations:
      'No investigations created yet. Create your first to start receiving leads!',
    dash_leads_by_investigation: 'Leads by Investigation',
    dash_no_leads: 'No leads submitted yet. Viewers can submit leads using !lead command in chat.',
    dash_quick_create_title: 'Create New Investigation',
    dash_quick_create_desc: 'Add a new investigation for viewers to submit leads',
    dash_quick_leads_title: 'View All Leads',
    dash_quick_leads_desc: 'See all submitted leads in one place',
    dash_quick_live_title: 'Streamer View',
    dash_quick_live_desc: 'Real-time view of leads as they come in',
    // Investigations list
    inv_toggle_activate: 'Mark as ongoing',
    inv_toggle_deactivate: 'Mark as completed',
    inv_activated: 'Investigation marked as ongoing',
    inv_deactivated: 'Investigation marked as completed',
    inv_toggle_failed: 'Failed to change status',
    inv_status_active: 'Ongoing',
    inv_status_inactive: 'Completed',
    inv_status_pending: 'Pending',
    inv_filter_status_all: 'All statuses',
    inv_filter_status_pending: 'Pending',
    inv_filter_status_active: 'Active',
    inv_filter_status_inactive: 'Inactive',
    inv_set_status: 'Change status',
    inv_conclusion_label: 'Conclusion',
    inv_conclusion_none: 'In progress',
    inv_conclusion_true: 'True',
    inv_conclusion_false: 'False',
    inv_conclusion_fallacious: 'Fallacious',
    inv_conclusion_completed: 'Completed',
    inv_conclusion_success: 'Conclusion saved',
    inv_conclusion_failed: 'Failed to save conclusion: {{error}}',
    inv_conclusion_inactive_note: 'Setting a conclusion marks the investigation as completed.',
    lead_conclusion_label: 'Lead conclusion',
    lead_conclusion_none: 'In progress',
    lead_conclusion_success: 'Lead conclusion saved',
    lead_conclusion_failed: 'Failed to save lead conclusion: {{error}}',
    inv_delete_confirm:
      'Are you sure you want to delete "{{name}}"? All associated leads will also be deleted.',
    inv_deleted: 'Investigation "{{name}}" deleted successfully',
    inv_delete_failed: 'Failed to delete investigation: {{error}}',
    inv_page_title: 'Investigations',
    inv_page_subtitle: 'Investigation management',
    inv_empty_title: 'No investigations created yet',
    inv_empty_body: 'Create your first investigation to start receiving leads from viewers',
    inv_empty_button: 'Create Your First Investigation',
    inv_card_created: 'Created:',
    inv_view_leads: 'View Leads',
    inv_leads_page_title: 'Leads',
    inv_leads_back: 'Back to Investigations',
    preview_article: 'Preview',
    inv_leads_add: 'Add Lead',
    inv_leads_empty_title: 'No leads yet',
    inv_leads_empty_body: 'Add the first lead for this investigation.',
    inv_lead_detail_back: 'Back to Leads',
    pagination_info: 'Page {{page}} of {{total}}',
    // Forms (create / edit)
    form_cancel: 'Cancel',
    form_create_title: 'Create New Investigation',
    form_create_subtitle: 'Create a new investigation for viewers to submit leads',
    form_create_submit: 'Create an investigation',
    form_create_success: 'Investigation "{{name}}" created successfully',
    form_create_error: 'Failed to create investigation: {{error}}',
    form_edit_title: 'Edit Investigation',
    form_edit_subtitle: 'Update the details for this investigation',
    form_edit_submit: 'Update Investigation',
    form_edit_success: 'Investigation "{{name}}" updated successfully',
    form_edit_error: 'Failed to update investigation: {{error}}',
    form_name_label: 'Investigation Name *',
    form_name_placeholder: 'e.g., The Great Climate Hoax',
    form_name_desc: 'A unique name for this investigation (visible to viewers)',
    form_desc_label: 'Description',
    form_desc_placeholder: 'e.g., Tips and tricks for React development',
    form_desc_helper: 'Optional description to help viewers understand the investigation',
    form_id_label: 'Investigation ID *',
    form_id_placeholder: 'e.g., react-best-practices',
    form_id_desc: 'A unique identifier for this investigation (used in !lead commands)',
    form_author_placeholder: 'e.g., Le Monde, BFMTV…',
    form_category_label: 'Category',
    form_category_placeholder: 'e.g., Politics, Media, Science…',
    form_category_desc: 'Category shown on the public investigations page',
    form_image_label: 'Cover Image',
    form_image_desc: 'Upload a file or paste an external URL (optional)',
    form_live_section: 'Associated video',
    form_live_date_label: 'Live date and time (optional)',
    form_live_date_desc: 'Date and time of the live. Leave empty for a simple video.',
    form_live_twitch_label: 'Twitch link',
    form_live_twitch_desc: 'Twitch stream URL (optional).',
    form_live_youtube_label: 'YouTube link',
    form_live_youtube_desc: 'URL of the live, replay or a simple YouTube video.',
    form_author_label: 'Author',
    form_author_desc: 'The user credited as author of this investigation',
    form_author_desc_lead: 'The user credited as author of this lead',
    form_author_desc_fact: 'The user credited as author of this fact',
    form_author_search_placeholder: 'Search by username or display name…',
    form_author_current: 'Current author:',
    form_author_clear: 'Remove author',
    form_author_none: 'No author assigned',
    form_investigation_search_placeholder: 'Search for an investigation…',
    form_investigation_clear: 'Remove linked investigation',
    form_investigation_none: 'No investigation linked',
    form_investigation_no_results: 'No investigation found',
    // Leads list
    leads_title: 'All Leads',
    leads_subtitle: 'Browse and manage all submitted leads',
    leads_search_placeholder: 'Search leads...',
    leads_all_topics: 'All Investigations',
    leads_filter_submitter: 'Filter by submitter...',
    leads_found: 'Found {{count}} leads',
    leads_empty_title: 'No leads found',
    leads_empty_body: 'Try adjusting your filters or check back later',
    leads_delete_confirm: 'Are you sure you want to delete this lead?',
    leads_deleted: 'Lead deleted successfully',
    leads_delete_failed: 'Failed to delete lead: {{error}}',
    leads_edit_dialog_title: 'Edit lead',
    leads_edit_title_label: 'Title',
    leads_edit_description_label: 'Description',
    leads_edit_image_label: 'Image',
    leads_edit_submit: 'Save changes',
    leads_edit_success: 'Lead updated successfully',
    leads_edit_failed: 'Failed to update lead: {{error}}',
    // Leads by investigation
    leads_by_inv_not_found: 'Investigation not found',
    leads_by_inv_not_found_body: "The investigation you're looking for doesn't exist.",
    leads_by_inv_view_all: 'View All Investigations',
    leads_by_inv_id: 'Investigation ID:',
    leads_by_inv_count: '{{count}} leads',
    leads_by_inv_sorted: 'Sorted by date (oldest first)',
    leads_by_inv_empty_title: 'No leads for this investigation yet',
    leads_by_inv_empty_body: 'Viewers can submit leads using !lead command in chat.',
    // LeadGroupList
    lead_group_empty: 'No leads found. Viewers can submit leads using !lead command in chat.',
    lead_group_more: '+{{count}} more leads',
    lead_group_count: '{{count}} lead(s)',
    // ImageField
    image_upload_aria: 'Upload cover image',
    image_click_replace: 'Click to replace',
    image_drop_prompt: 'Click or drag & drop to upload',
    image_file_hint: 'JPG, PNG, WebP, GIF · max 30 MB',
    image_remove: 'Remove image',
    image_url_separator: 'or enter a URL',
    // Live view
    live_title: 'Streamer View',
    live_subtitle: 'Live management',
    live_refresh: 'Refresh',
    live_auto_on: 'Auto-refresh On',
    live_auto_off: 'Auto-refresh Off',
    live_filter_label: 'Filter by investigation:',
    live_all_investigations: 'All Investigations ({{count}} leads)',
    live_topic_leads: '{{count}} leads',
    live_oldest_first: 'Oldest First',
    live_newest_first: 'Newest First',
    live_stat_total_leads: 'Total Leads',
    live_stat_active: 'Active Investigations',
    live_stat_submitters: 'Unique Submitters',
    live_tab_by_investigation: 'By Investigation',
    live_tab_all: 'All Leads',
    live_empty_title: 'No leads yet',
    live_empty_body: 'Viewers can submit leads using !lead command in chat.',
    live_no_ongoing_title: 'No ongoing investigations',
    live_no_ongoing_body: 'Mark investigations as ongoing in the management page to see them here.',
    live_all_leads_title: 'All Leads ({{count}})',
    live_no_leads: 'No leads submitted yet',
    live_refreshed: 'Refreshed successfully',
    live_refresh_failed: 'Failed to refresh',
    // Active investigation / lead
    live_bot_panel_title: 'Twitch Bot',
    live_bot_panel_show: 'Show',
    live_bot_panel_hide: 'Hide',
    live_active_section_title: 'Active Context',
    live_active_investigation_label: 'Active Investigation',
    live_no_active_investigation:
      'No active investigation. Click "Set as Active" on an investigation below.',
    live_active_lead_label: 'Active Lead',
    live_no_active_lead: 'No leads for this investigation yet.',
    live_active_fact_label: 'Active Fact',
    live_no_active_fact: 'No active fact.',
    live_set_active_investigation: 'Set as Active',
    live_set_active_lead: 'Set as Active Lead',
    live_active_badge: 'Active',
    live_active_lead_badge: 'Active Lead',
    live_active_fact_badge: 'Active Fact',
    live_original_source_badge: 'Original',
    live_set_active_fact: 'Set as active fact',
    live_unset_active_fact: 'Unset active fact',
    live_active_fact_set: 'Active fact set',
    live_active_fact_cleared: 'Active fact cleared',
    live_active_fact_failed: 'Failed to update active fact',
    live_commands_reference: 'Chat Commands',
    // Settings
    settings_title: 'Settings',
    settings_profile_title: 'Profile',
    settings_profile_desc: 'Manage your profile settings and preferences',
    settings_profile_placeholder: 'Profile settings will be available in a future update.',
    settings_twitch_title: 'Twitch Bot Connection',
    settings_twitch_desc:
      'Authenticate the chat bot via Twitch OAuth. Tokens are stored in the database and refreshed automatically — no more manual token commands.',
    settings_commands_title: 'Available Chat Commands',
    settings_notif_title: 'Notifications',
    settings_notif_desc: 'Configure how you receive notifications',
    settings_notif_placeholder: 'Notification settings will be available in a future update.',
    settings_tech_title: 'Technologies',
    // Site identity (white-label)
    settings_site_title: 'Site Identity',
    settings_site_card_desc: "Customise your site's name, description, and theme",
    settings_site_name_label: 'Site name',
    settings_site_name_placeholder: 'E.g.: My Investigation Site',
    settings_site_description_label: 'Description',
    settings_site_description_placeholder: 'A short description of your site',
    settings_theme_label: 'Theme (logged-in users)',
    settings_theme_desc:
      'Appearance applied for you once logged in, both in the management area and on public pages as you view them.',
    settings_public_theme_label: 'Public theme (anonymous visitors)',
    settings_public_theme_desc:
      'Appearance seen by anonymous visitors on the public pages of the site.',
    settings_site_save_button: 'Save',
    settings_site_saved: 'Site settings saved',
    settings_homepage_layout_label: 'Homepage layout',
    settings_homepage_layout_classic: 'Classic',
    settings_homepage_layout_news: 'News front page',
    // Social networks
    settings_social_title: 'Social Networks',
    settings_social_card_desc: 'Configure the social network links displayed on the About page',
    settings_social_save_button: 'Save',
    settings_social_saved: 'Social networks saved',
    settings_social_x_label: 'X (formerly Twitter)',
    settings_social_bluesky_label: 'BlueSky',
    settings_social_facebook_label: 'Facebook',
    settings_social_instagram_label: 'Instagram',
    settings_social_tiktok_label: 'TikTok',
    settings_social_youtube_label: 'YouTube',
    settings_social_twitch_label: 'Twitch',
    settings_social_discord_label: 'Discord',
    settings_social_footer_links_title: 'Footer links',
    settings_social_footer_links_desc:
      'Select up to 6 networks to display in the footer (only networks with a configured URL can be enabled).',
    // Breaking news banner
    settings_breaking_title: 'Breaking News Banner',
    settings_breaking_card_desc: 'Configure the breaking news bar shown on the news homepage',
    settings_breaking_active_label: 'Active',
    settings_breaking_message_label: 'Message',
    settings_breaking_investigation_label: 'Linked investigation (optional)',
    settings_breaking_link_mode_label: 'Banner link',
    settings_breaking_link_mode_none: 'None',
    settings_breaking_link_mode_investigation: 'Linked investigation',
    settings_breaking_link_mode_link: 'Custom link',
    settings_breaking_link_label: 'Custom link',
    settings_breaking_save_button: 'Save',
    settings_breaking_saved: 'Breaking news settings saved',
    // Language selector
    settings_lang_section_title: 'Language for settings',
    settings_lang_section_desc: 'Define the site settings for each available language.',
    twitch_checking: 'Checking connection…',
    twitch_connected_as: 'Connected as',
    twitch_expires_in: 'expires in {{minutes}} min',
    twitch_expired: 'Token expired for @{{username}} — re-authentication required',
    twitch_not_connected: 'Bot not connected',
    twitch_disconnect: 'Disconnect Bot',
    twitch_reauthenticate: 'Re-authenticate Bot',
    twitch_connect: 'Connect Bot with Twitch',
    twitch_language_label: 'Bot chat language',
    twitch_language_en: '🇬🇧 English',
    twitch_language_fr: '🇫🇷 French',
    twitch_language_desc:
      'All bot messages in Twitch chat (welcome, commands, announcements) will use this language.',
    twitch_language_saved: 'Language saved.',
    bot_send_welcome: 'Send Welcome Message',
    bot_send_welcome_desc: 'Sends the bot introduction and command list to all connected chats.',
    bot_welcome_sent: 'Welcome message sent.',
    twitch_connected_toast: 'Bot @{{username}} connected successfully!',
    twitch_connected_generic: 'Twitch bot connected successfully!',
    twitch_denied: 'Twitch authorisation was denied.',
    youtube_checking: 'Checking YouTube status...',
    youtube_connected_as: 'Connected as',
    youtube_expires_in: 'Expires in {{minutes}} min',
    youtube_expired: 'Token expired for {{username}}',
    youtube_not_connected: 'YouTube bot not connected',
    youtube_disconnect: 'Disconnect bot',
    youtube_connect: 'Connect YouTube bot',
    youtube_reauthenticate: 'Reconnect YouTube bot',
    // Delete account (Danger Zone)
    profile_delete_title: 'Delete Account',
    profile_delete_desc: 'Permanently remove your account and all associated data.',
    profile_delete_warning:
      'This will permanently delete your profile, your comments, and your suggestion votes. Your investigations, leads, and suggestions will be kept and reassigned to the streamer. This action cannot be undone.',
    profile_delete_btn: 'Delete my account…',
    profile_delete_confirm_label: 'To confirm, type your username below:',
    profile_delete_confirm_placeholder: 'Your username',
    profile_delete_confirm_btn: 'Yes, permanently delete',
    profile_delete_cancel: 'Cancel',
    profile_delete_success: 'Your account has been permanently deleted.',
    profile_delete_error: 'Failed to delete account. Please try again.',
  },
  about: {
    title: 'About',
    description:
      '{{appName}} is a citizen-led, collaborative investigation platform fighting disinformation.',
    follow_us: 'Follow us on',
  },
  read_mode: {
    print: 'Print',
    share: 'Share',
    share_facebook: 'Share on Facebook',
    share_x: 'Share on X',
    share_bluesky: 'Share on Bluesky',
    toc_title: 'In this investigation',
    source_label: 'Original source',
    notes_label: 'Analyses and Synthesis',
    facts_title: 'Facts',
    no_facts: 'No facts for this lead yet.',
    by: 'By',
    comments_link: 'Comments',
    reading_time_one: '{{count}} minute',
    reading_time_other: '{{count}} minutes',
    preview_banner: "You're viewing a preview that includes unpublished content.",
    preview_banner_public: "You're viewing the public version, showing only published content.",
    preview_banner_view_public: 'View published version',
    preview_banner_view_preview: 'Back to preview',
    listen: {
      region_label: 'Article audio player',
      cta: 'Listen to this article',
      duration_one: '{{count}} min',
      duration_other: '{{count}} min',
      play_label: 'Listen to this article, {{duration}}',
      pause: 'Pause',
      resume: 'Resume',
      replay: 'Listen again',
      stop: 'Stop',
      seek_label: 'Playback position',
      position_text: '{{elapsed}} of {{total}}',
      speed_label: 'Playback speed: {{rate}}×',
      more_options: 'Playback options',
      voice_label: 'Voice',
      voice_auto: 'Automatic',
      voice_quality_high: 'Natural',
      voice_low_quality_hint: 'Limited-quality system voice',
      now_listening: 'Now playing',
      status_playing: 'Playing',
      status_paused: 'Paused',
      status_ended: 'Finished',
      error: 'Playback interrupted',
      retry: 'Try again',
      minutes_seconds: '{{m}} min {{s}} s',
      preparing: 'Preparing the voice…',
      preparing_percent: 'Downloading the voice… {{percent}}%',
      consent_title: 'Site voice',
      consent_body:
        'Site voice: a ~{{size}} MB download per language, only once. The same voices on every device.',
      consent_download: 'Download',
      consent_device: 'Use the device voice',
      engine_label: 'Voice engine',
      engine_site: 'Site voice',
      engine_device: 'Device voice',
      engine_device_unavailable: 'No device voice for this language',
      active_voice: 'Active voice: {{name}}',
      active_voice_device: 'Active voice: device voice',
      credits_link: 'Audio credits',
      fallback_notice: "The site voice couldn't be loaded: using the device voice.",
    },
  },
  article_comments: {
    title: 'Comments',
    no_comments: 'No comments yet. Be the first!',
    placeholder: 'Share your thoughts...',
    submit: 'Post Comment',
    login_to_comment: 'Sign in to leave a comment',
    login_to_reply: 'Sign in to reply',
    reply: 'Reply',
    reply_placeholder: 'Write your reply...',
    reply_submit: 'Post Reply',
    cancel_reply: 'Cancel',
    pending: 'Pending validation',
    approve: 'Approve',
    edit: 'Edit',
    delete: 'Delete',
    edit_dialog_title: 'Edit comment',
    edit_submit: 'Save',
    approved_toast: 'Comment approved',
    deleted_toast: 'Comment deleted',
    updated_toast: 'Comment updated',
    delete_confirm: 'Delete this comment?',
    my_pending_note: 'Your comment is pending validation',
    published_toast: 'Comment published!',
    reply_published_toast: 'Reply published!',
    moderate_validate: 'Validate',
    moderate_reject: 'Reject',
  },
  pwa_install: {
    title: 'Install Balivernologie on your home screen',
    description: 'Add the app to your home screen for one-tap, full-screen access — even offline.',
    ios_step_share: 'Tap Share, in the bar at the bottom of your browser.',
    ipados_step_share: 'Tap Share, in the toolbar at the top of your browser.',
    ios_step_more: 'Then “More”, to reveal the full list.',
    ios_step_add: 'Then “Add to Home Screen”, and confirm with “Add”.',
    android_step_menu: 'Open the browser menu, at the top right.',
    android_step_add: 'Choose “Add to Home screen”, then confirm.',
    install_action: 'Install the app',
    dismiss: 'No thanks',
    close: 'Close the invitation',
  },
  audio_credits: {
    page_title: 'Audio credits',
    intro:
      'The "Listen to this article" feature uses synthetic voices downloaded once into your browser, with your consent, and then run locally: no text is sent to any server.',
    voices_title: 'Voices',
    voice_license: 'License',
    voice_credit: 'Credit',
    voice_source:
      'Voice models come from the rhasspy/piper-voices Hugging Face repository, at revision {{revision}}.',
    piper_title: 'Piper',
    piper_body:
      "Speech synthesis is based on Piper (rhasspy/piper, MIT license). In-browser execution uses Diffusion Studio's piper-wasm (MIT license) and is adapted from Mintplex Labs' piper-tts-web (MIT license).",
    espeak_title: 'eSpeak NG',
    espeak_body:
      'Text phonemization uses eSpeak NG, distributed under the GNU GPL version 3 or later. Its source code is available at:',
    onnx_title: 'ONNX Runtime Web',
    onnx_body:
      'Models are run by ONNX Runtime Web (Microsoft, MIT license), compiled to WebAssembly.',
  },
  cookies: {
    banner_title: 'We value your privacy',
    banner_description:
      'We use a strictly necessary cookie to remember your consent choice, and — only with your consent — a category for third-party embedded media.',
    banner_privacy_link: 'Learn more in our privacy policy',
    accept_all: 'Accept all',
    refuse_all: 'Refuse all',
    customize: 'Customize',
    preferences_title: 'Cookie preferences',
    preferences_description:
      'Choose which categories of cookies and local storage you allow. You can change this choice at any time from the "Cookies" link in the footer.',
    category_necessary_title: 'Strictly necessary',
    category_necessary_description:
      'Required to record your consent choice itself. Always active — cannot be disabled.',
    category_media_title: 'Third-party embedded media',
    category_media_description:
      'Allows embedded content from third-party services such as YouTube, Vimeo or maps. Disabled by default.',
    save_preferences: 'Save preferences',
    embed_blocked: 'This content requires third-party embedded media consent to load.',
    embed_blocked_named:
      'This content from {{service}} requires third-party embedded media consent to load.',
    embed_accept: 'Accept and load content',
    page_title: 'Cookie policy',
    page_intro:
      'This page explains what a cookie is, what we use, why, for how long, and how you can change your choice at any time.',
    page_what_is_title: 'What is a cookie?',
    page_what_is_body:
      'A cookie (or an equivalent local storage entry) is a small piece of data saved by your browser when you visit a website. It can be used to remember information, such as your preferences or a choice you made, from one visit to the next.',
    page_what_we_use_title: 'What we use, and why',
    page_categories_intro: 'We use exactly two categories of cookies/local storage, no more:',
    page_category_necessary:
      'Strictly necessary — a single first-party localStorage entry that records the consent choice itself (which categories you accepted, when, and which version of this policy). Without it we would not know that you already answered, and the banner would reappear on every visit. This is not toggleable, since it is what makes your other choices possible in the first place.',
    page_category_media:
      'Third-party embedded media — reserved for future third-party embeds (e.g. YouTube, Vimeo, interactive maps) that may be added to the site. Nothing from these services loads until you explicitly consent, either from the banner, the preferences panel, or the one-click "accept and load" button shown on a gated embed itself.',
    page_first_third_title: 'First-party vs. third-party',
    page_first_third_body:
      'The consent record itself is first-party (stored only in your browser, only for this site). The "third-party embedded media" category, once accepted, allows content served directly by an outside provider (e.g. YouTube) to load in the page — that provider may then set its own cookies, governed by its own policy.',
    page_duration_title: 'How long does consent last?',
    page_duration_body:
      'Your consent choice is stored for 6 months. After that it expires automatically and the banner is shown again so you can confirm or change your choice. It is also reset whenever this cookie policy changes in a way that requires asking again.',
    page_change_title: 'Changing your choice',
    page_change_body:
      'You can review or change your preferences at any time by clicking the button below, or via the "Cookies" link in the footer of every page.',
    page_change_button: 'Manage my cookie preferences',
    page_browser_title: 'Browser controls',
    page_browser_body:
      "Independently of this site's consent tool, your browser lets you view, delete, or block cookies and local storage in general — check your browser's settings or help pages for the exact steps, as they vary by browser and version.",
  },
  legal: {
    mentions: {
      page_title: 'Legal notice',
      publisher_title: 'Website publisher',
      publisher_body:
        'This website is published by Bertrand PRESLES, an individual acting in a personal, non-professional capacity. As this is a personal, non-commercial project, no SIRET/RCS registration number, share capital, or VAT number applies.',
      publisher_address_label: 'Address',
      publisher_address_value: '18 Bis Rue du Petit Village, 44800 Saint-Herblain, France',
      director_title: 'Director of publication',
      director_body: 'Bertrand PRESLES.',
      contact_title: 'Contact',
      contact_body: 'For any question regarding this website, you can write to:',
      host_title: 'Hosting',
      host_frontend_label: 'Website (frontend) hosted by',
      host_frontend_value: 'Vercel Inc., 340 S Lemon Ave #4133, Walnut, CA 91789, USA',
      host_frontend_site: 'https://vercel.com',
      host_backend_label: 'Application backend (API) hosted by',
      host_backend_value:
        'Koyeb — a service owned by Mistral AI (SIREN 952 418 325), 15 rue des Halles, 75001 Paris, France. Koyeb (SIREN 850 183 948) was transferred to Mistral AI by way of a transmission universelle de patrimoine and struck off the French trade register on 12 May 2026.',
      host_backend_site: 'https://www.koyeb.com',
      host_database_label: 'Database hosted by',
      host_database_value:
        'Neon — PostgreSQL database hosted in the United Kingdom (London), at AWS.',
      host_database_site: 'https://neon.com',
      host_note:
        'See the privacy policy for details of data transfers and the safeguards applying to each of these processors.',
    },
    privacy: {
      page_title: 'Privacy policy',
      intro_title: 'Introduction',
      intro_body:
        'This privacy policy explains what personal data Balivernologie collects, why, on what legal basis, for how long, who it may be shared with, and what rights you have over it, in accordance with the GDPR.',
      controller_title: 'Data controller',
      controller_body:
        'The data controller is Bertrand PRESLES, operating this website as an individual, non-professional project. You can exercise your rights or ask any question by writing to:',
      data_title: 'What data we collect, and why',
      data_intro:
        'We only collect data you provide directly by creating an account, submitting content, or interacting with the site. We do not use analytics or advertising cookies, and we do not collect IP addresses, browser fingerprints, or any session/tracking cookie.',
      data_account_title: 'Account data',
      data_account_body:
        'When you create an account: username, email address (optional), a securely hashed password (never stored in plain text — not applicable for accounts created via Google or Twitch sign-in), profile picture, a short biography, your role, and — if you enable it — two-factor authentication (TOTP) settings. If you sign in with Google or Twitch, we also store the corresponding provider account identifier. A hashed session refresh token is stored to keep you signed in, valid for 7 days.',
      data_public_activity_title: 'Public contributions',
      data_public_activity_body:
        'Comments, leads, facts, and investigation suggestions you submit are stored together with your public username so they can be displayed and attributed on the site. Comments require an account — we do not collect anonymous or guest comments, and we do not record an email address or IP address alongside a comment.',
      data_uploads_title: 'Uploaded images',
      data_uploads_body:
        'Images you upload are stored directly in our database, together with an identifier of the account that uploaded them.',
      data_recaptcha_title: 'Registration security (reCAPTCHA)',
      data_recaptcha_body:
        'Account registration is protected by Google reCAPTCHA v3 to limit automated abuse. The reCAPTCHA token is verified directly with Google; we do not store or forward your IP address as part of this check.',
      legal_basis_title: 'Legal basis for processing',
      legal_basis_account:
        'Account creation, authentication, and displaying your public contributions: performance of the contract you enter into by creating an account (GDPR Art. 6(1)(b)).',
      legal_basis_media:
        'Loading third-party embedded media: your explicit consent (GDPR Art. 6(1)(a)), see the cookie policy.',
      legal_basis_recaptcha:
        'Registration abuse prevention via reCAPTCHA: our legitimate interest in protecting the service from automated abuse (GDPR Art. 6(1)(f)).',
      retention_title: 'Retention periods',
      retention_body:
        'As a policy commitment (retention is not yet automated in our systems): account data is kept for as long as your account remains active, and you may request its deletion at any time by contacting us — see "Your rights" below. Public contributions (comments, leads, facts, suggestions) may be retained for the historical record of an investigation even if you later delete your account, though the username shown may be anonymized on request.',
      recipients_title: 'Who your data is shared with',
      recipients_intro:
        'Your data is only shared with the technical service providers strictly needed to run the site, all acting as data processors, plus the identity providers you choose to sign in with:',
      recipients_vercel: 'Vercel Inc. (USA) — hosts the website frontend.',
      recipients_koyeb:
        'Koyeb (a service owned by Mistral AI, 15 rue des Halles, 75001 Paris, France) — hosts the application backend (server). Further details on their role as a processor are available at their own site.',
      recipients_neon:
        'Neon — hosts the PostgreSQL database where account and content data is stored, hosted in the United Kingdom (London), at AWS. Further details on their role as a processor are available at their own site.',
      recipients_google:
        'Google — provides optional "Sign in with Google" authentication and the reCAPTCHA anti-abuse check.',
      recipients_twitch:
        'Twitch — provides optional "Sign in with Twitch" authentication, and operates the chat bot used to submit leads/facts from stream chat.',
      transfers_title: 'International data transfers',
      transfers_body:
        "The database (Neon) is hosted in the United Kingdom (London), at AWS. The UK is covered by a European Commission adequacy decision under GDPR Article 45, which recognises its data protection level as equivalent to the EU's — so this transfer does not require an additional safeguard on that basis. Vercel (frontend hosting) and Google (authentication, reCAPTCHA) are based in the United States; for those transfers outside the European Economic Area, we rely on appropriate safeguards such as Standard Contractual Clauses and/or the EU-US Data Privacy Framework, as applicable. The backend host (Koyeb, a service owned by Mistral AI) is a French company established in the European Union; the actual processing region of its servers is not confirmed at this time.",
      rights_title: 'Your rights',
      rights_intro:
        'In accordance with the GDPR, you have the following rights over your personal data, exercisable by writing to us at the contact address above:',
      rights_access: 'Right of access to your personal data.',
      rights_rectification: 'Right to rectification of inaccurate or incomplete data.',
      rights_erasure: 'Right to erasure ("right to be forgotten").',
      rights_restriction: 'Right to restriction of processing.',
      rights_portability: 'Right to data portability.',
      rights_objection: 'Right to object to processing based on legitimate interest.',
      rights_withdraw_consent:
        'Right to withdraw consent at any time, where processing is based on consent.',
      complaint_title: 'Right to lodge a complaint',
      complaint_body:
        'If you believe your data protection rights are not being respected, you may lodge a complaint with the French data protection authority (CNIL):',
      complaint_address: '3 Place de Fontenoy, TSA 80715, 75334 Paris Cedex 07, France',
      complaint_website: 'https://www.cnil.fr',
    },
  },
  seo: {
    home_title: 'Bullshitology - Investigations and fact-checking to debunk nonsense',
    home_description:
      'Citizen-led fact-checking investigations: we take apart rumours and disinformation, with sources. Ongoing investigations, open and verifiable method.',
    investigations_title: 'Investigations',
    investigations_description:
      'Browse every fact-checking investigation led by the Balderdashology community, active or closed.',
    investigators_title: 'Investigators',
    investigators_description:
      'Meet the community of investigators contributing facts and leads to Balderdashology.',
    about_title: 'About',
    about_description:
      'Learn about Balderdashology, a citizen-led, collaborative investigation platform fighting disinformation.',
    mentions_legales_title: 'Legal notice',
    mentions_legales_description: 'Publisher identity and hosting information for Balderdashology.',
    confidentialite_title: 'Privacy policy',
    confidentialite_description:
      'How Balderdashology collects, uses and protects your personal data.',
    cookies_title: 'Cookie policy',
    cookies_description: 'Which cookies Balderdashology uses and how to manage your preferences.',
    audio_credits_title: 'Audio credits',
    audio_credits_description:
      'Voices, licenses and open-source software used by the "Listen to this article" feature.',
  },
  categories: {
    page_title: 'Categories',
    page_subtitle: 'Manage categories and their labels in each language.',
    filter_placeholder: 'Filter by name',
    add_button: 'Add',
    add_title: 'Add a category',
    edit_title: 'Edit category',
    label_fr: 'French',
    label_en: 'English',
    label_es: 'Spanish',
    label_fr_placeholder: 'e.g. Politique',
    label_en_placeholder: 'e.g. Politics',
    label_es_placeholder: 'e.g. Política',
    col_usage: 'Investigations',
    col_actions: 'Actions',
    empty: 'No categories found.',
    add_submit: 'Add',
    save: 'Save',
    create_success: 'Category added.',
    update_success: 'Category updated.',
    delete_success: 'Category deleted.',
    delete_confirm: 'Delete this category?',
    delete_in_use:
      'This category is used by {{count}} investigation(s). Choose a replacement category to reassign them to before deleting it.',
    delete_reassign_label: 'Replacement category',
    delete_reassign_filter: 'Filter categories by name',
    delete_reassign_empty: 'No matching category.',
    edit_aria: 'Edit category {{name}}',
    delete_aria: 'Delete category {{name}}',
  },
  taxonomy: {
    search_label: 'Search or create a category',
    suggestions_label: 'Category suggestions',
    suggestions_popular: 'Most used categories',
    suggestions_count_one: '{{count}} suggestion available',
    suggestions_count_other: '{{count}} suggestions available',
    usage_count_one: '{{count}} investigation',
    usage_count_other: '{{count}} investigations',
    no_results: 'No category found.',
    create_term: 'Create "{{name}}"',
    creating: 'Creating…',
    create_error: 'Could not create the category "{{name}}": {{message}}',
    remove_term: 'Remove the category {{label}}',
    untranslated_badge_title:
      'Not translated yet: the {{locale}} name is shown until a label exists.',
    label_input_aria: 'Label of "{{name}}" in {{locale}}',
    labels_shared_hint:
      'A label applies to every investigation that uses this category, not only this one.',
    canonical_name_hint: "The category's original name (in this language)",
    missing_source_labels_title: 'Categories created in another language: label in {{locale}}',
  },
  translations: {
    locale_fr: 'French',
    locale_en: 'English',
    locale_es: 'Spanish',
    source_language_label: 'Written in (fixed once translations exist)',
    source_language_frozen:
      'The source language can no longer be changed: at least one translation already exists for this content.',
    tab_source: 'Source',
    source_field_label: 'source ({{locale}})',
    field_stale: 'source changed',
    field_optional: 'optional',
    no_categories: 'No categories to translate for this investigation.',
    badge_missing: '{{count}} missing',
    badge_stale: 'source changed',
    badge_complete: 'complete',
    dashboard_title: 'Translation dashboard',
    dashboard_subtitle:
      'Published investigations and their per-language completeness — what still needs translating.',
    dashboard_col_investigation: 'Investigation',
    dashboard_col_locale: 'Language',
    dashboard_col_status: 'Status',
    dashboard_col_missing: 'Missing fields',
    dashboard_col_stale: 'Stale fields',
    dashboard_empty: 'No published investigations yet.',
    dashboard_edit_link: 'Edit',
    dashboard_export_action: 'Export',
    dashboard_import_action: 'Import',
    dashboard_import_in_progress: 'Importing…',
    dashboard_import_in_progress_percent: 'Importing… {{percent}}%',
    dashboard_export_error: 'Failed to export translations',
    dashboard_import_error: 'Failed to import translations',
    dashboard_import_invalid_file: 'Only JSON files are allowed',
    dashboard_import_result_title: 'Import completed',
    dashboard_import_updated:
      '{{investigations}} investigation(s), {{leads}} lead(s) and {{facts}} fact(s) updated.',
    dashboard_import_skipped_title: 'Skipped items (deleted since export)',
    dashboard_import_errors_title: 'Some items could not be imported',
    dashboard_import_close: 'Close',
    detail_investigation_title: 'Investigation detail',
    detail_investigation_subtitle: 'Translation completeness by lead.',
    detail_lead_title: 'Lead detail',
    detail_lead_subtitle: 'Translation completeness by fact.',
    detail_col_lead: 'Lead',
    detail_col_fact: 'Fact',
    detail_row_investigation_own: 'Investigation fields',
    detail_row_lead_own: 'Lead fields',
    detail_leads_empty: 'This investigation has no leads yet.',
    detail_facts_empty: 'This lead has no facts yet.',
    detail_back_to_dashboard: 'Back to dashboard',
    detail_back_to_investigation: 'Back to investigation',
    detail_not_found: 'Not found.',
    detail_edit_lead_aria: 'Edit lead {{title}}',
    detail_edit_fact_aria: 'Edit fact {{title}}',
  },
}
